"use client";

import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, Quote, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselApi, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Testimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  const testimonials = [{
    quote: "HydroRoof uratował nasz dach przed kosztowną wymianą. Metoda natryskowa jest szybka, a efekt szczelności przerósł nasze oczekiwania. Pełen profesjonalizm.",
    name: "Marek W.",
    childAge: "Właściciel domu jednorodzinnego",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/klient_dom.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/klient_dom.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/klient_dom.png-wvc-sizes"
  }, {
    quote: "Jako zarządca nieruchomości szukałem trwałego rozwiązania dla dachu płaskiego. Hydroizolacja bezspoinowa to strzał w dziesiątkę. Zero przecieków od dwóch lat.",
    name: "Anna K.",
    childAge: "Zarządca nieruchomości",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/klient_zarzadca.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/klient_zarzadca.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/klient_zarzadca.webp-wvc-sizes"
  }, {
    quote: "Szybka reakcja na zgłoszenie i fachowe doradztwo. Nasza hala produkcyjna wreszcie jest sucha, a koszty renowacji były znacznie niższe niż wymiana pokrycia.",
    name: "Piotr S.",
    childAge: "Właściciel zakładu przemysłowego",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/klient_hala.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/klient_hala.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/klient_hala.webp-wvc-sizes"
  }, {
    quote: "HydroRoof to ekipa, której można zaufać. Taras po hydroizolacji wygląda świetnie i w końcu nie przecieka do garażu. Polecam każdemu na Śląsku.",
    name: "Katarzyna B.",
    childAge: "Właścicielka domu z tarasem",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/klient_taras.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/klient_taras.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/klient_taras.png-wvc-sizes"
  }, {
    quote: "Technologia natryskowa to przyszłość. Bez zrywania starej papy, bez bałaganu, a dach wygląda jak nowy. Bardzo solidna firma.",
    name: "Tomasz J.",
    childAge: "Deweloper",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/klient_deweloper.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/klient_deweloper.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/klient_deweloper.png-wvc-sizes"
  }, {
    quote: "Dach przeciekał przy każdym deszczu. HydroRoof uszczelnił wszystko w jeden dzień. Jesteśmy bardzo zadowoleni z jakości wykonania.",
    name: "Ewa M.",
    childAge: "Wspólnota mieszkaniowa",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/klient_wspolnota.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/klient_wspolnota.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/klient_wspolnota.png-wvc-sizes"
  }];
  useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  return;
}